import { useRef } from "react";

function generateUUID(): string {
  if (typeof window !== "undefined" && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function useTabOwnership(): { currentTabId: string } {
  const ref = useRef<string>("");
  if (!ref.current) {
    ref.current = generateUUID();
  }
  return { currentTabId: ref.current };
}
